import { Controller } from "@hotwired/stimulus"

/**
 * Shows the hint text matching the currently-checked radio in a
 * match-mode-style toggle. All hint nodes live in the DOM; we toggle
 * `hidden` on them based on the checked radio's value.
 *
 * Usage:
 *   <div data-controller="match-mode-hint">
 *     <input type="radio" name="..." value="strict"
 *            data-match-mode-hint-target="radio"
 *            data-action="change->match-mode-hint#update" />
 *     ...
 *     <span data-match-mode-hint-target="hint" data-mode="strict">...</span>
 *     <span data-match-mode-hint-target="hint" data-mode="lenient" hidden>...</span>
 *   </div>
 */
export default class extends Controller {
  static targets = ["radio", "hint"]

  declare readonly radioTargets: HTMLInputElement[]
  declare readonly hintTargets: HTMLElement[]

  connect() {
    this.update()
  }

  update() {
    const checked = this.radioTargets.find((r) => r.checked)
    const mode = checked?.value

    this.hintTargets.forEach((hint) => {
      hint.hidden = hint.dataset.mode !== mode
    })
  }
}
